import { AfterViewInit, Component, DoCheck, Input, KeyValueDiffer, KeyValueDiffers, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ApiService, LoggerService, User, SystemChatMessage } from 'angular-lib';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ez-chat-system',
    styles: [require('./system.component.less')],
    template: require('./system.component.html')
})
export class SystemComponent implements AfterViewInit, DoCheck, OnInit, OnChanges {
    @Input() public systemMessage: SystemChatMessage;
    @Input() public user: User;
    @Input() public me: User;
    private differ: KeyValueDiffer<any, any>;

    constructor(
        private apiService: ApiService,
        private differs: KeyValueDiffers,
        private translationService: TranslateService
    ) {}

    public ngOnInit() {
        this.differ = this.differs.find(this.systemMessage).create();
    }

    public ngAfterViewInit(): void {
        if (this.systemMessage.needReadsUpdate() && this.systemMessage.id > 0) {
            // this.setMessageRead();
        }
    }

    public ngDoCheck() {
        let changes = this.differ.diff(this.systemMessage);
        if (changes) {
            // check if systemMessage id change
            changes.forEachChangedItem(change => {
                if (change.key === 'id' && change.currentValue > 0) {
                    LoggerService.info('MESSAGE ID CHANGED');
                    this.setMessageRead();
                }
            });
        }
    }


    public ngOnChanges(changes: SimpleChanges): void {
        // Get display names when available
        if (changes.hasOwnProperty('user') && changes.user.currentValue && this.systemMessage.direction === 'to') {
            this.translateContent(changes.user.currentValue.displayname);
        }
        if (changes.hasOwnProperty('me') && changes.me.currentValue && this.systemMessage.direction === 'from') {
            this.translateContent(changes.me.currentValue.displayname)
        }
    }

    private setMessageRead() {
        // TODO
    }

    private ucFirst(string: string): string {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    private translateContent(pseudo: string) {
        this.translationService.get(this.systemMessage.content).subscribe(res => {
            this.systemMessage.content = res.replace('{{pseudo}}', this.ucFirst(pseudo));
            if (this.systemMessage.getPseudoBeforeContent()) {
                this.systemMessage.content = this.ucFirst(pseudo) + ' ' + this.systemMessage.content;
            }
            if (this.systemMessage.getPseudoAfterContent()) {
                this.systemMessage.content = this.systemMessage.content + ' ' + this.ucFirst(pseudo);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/chat/childs/system/system.component.ts